var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{attrs:{"color":"primary","to":("/case/details/" + (_vm.data.id))}},[_vm._v(" View File ")])}
var staticRenderFns = []

export { render, staticRenderFns }